module.exports = __webpack_public_path__ + "static/img/装饰8.e186d26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰8.svg
// module id = 64Sd
// module chunks = 2